var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"allpay"}}),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center","color":"#fff"}},[_vm._v("\n    当月支出(元)：\n    "),_c('span',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(this.utils.formatMoney(_vm.allMoney)))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07924187","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/data/allPay.vue
// module id = null
// module chunks = 